/**
 * Public catalogue reads — P-Q004 taxonomy, P-Q005/P-Q006 models,
 * P-Q007 the filter contract.
 *
 * These four are what make structured search legible: the unit itself carries
 * only a `model_id`, so the manufacturer and model name a user reads on a card
 * come from here, and the filters they may use come from P-Q007 rather than
 * from a hard-coded list this client invented.
 */
import { apiGet } from '../client.js';
export async function fetchTaxonomy(level) {
    const result = await apiGet('/v1/taxonomy', level ? { level } : undefined);
    return result.items;
}
export async function fetchModels(params) {
    const result = await apiGet('/v1/catalog/models', params);
    return result.items;
}
export async function fetchModel(id) {
    return apiGet(`/v1/catalog/models/${id}`);
}
export async function fetchAttributes(scope) {
    const result = await apiGet('/v1/catalog/attributes', scope ? { scope } : undefined);
    return result.items;
}
//# sourceMappingURL=catalog.js.map